import { render, staticRenderFns } from "./omsOrders.vue?vue&type=template&id=d5754d58&scoped=true&"
import script from "./omsOrders.vue?vue&type=script&lang=js&"
export * from "./omsOrders.vue?vue&type=script&lang=js&"
import style0 from "./omsOrders.vue?vue&type=style&index=0&id=d5754d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5754d58",
  null
  
)

export default component.exports